import { useLocation, useNavigate, Outlet } from 'react-router-dom'
import { CustomTabs } from '@/components/ui/custom-tabs'

export function FinancasPage() {
  const location = useLocation()
  const navigate = useNavigate()
  
  // Determina a aba ativa baseada na rota atual
  const activeTab = location.pathname.includes('/administracao') ? 'administracao' : 'painel'

  const tabs = [
    { id: 'painel', label: 'Painel' },
    { id: 'administracao', label: 'Administração' },
  ]

  const handleTabClick = (tabId: string) => {
    navigate(`/financas/${tabId}`)
  }

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-3xl font-bold tracking-tight">Finanças</h1>
          <p className="text-muted-foreground">
            Gerencie as finanças da igreja de forma eficiente
          </p>
        </div>
      </div>

      <CustomTabs tabs={tabs} activeTab={activeTab} onTabClick={handleTabClick} />

      <Outlet />
    </div>
  )
}